import type { VariablesOf } from 'relay-runtime';

import { createRelayResource } from '@townsquare/relay-utils';
import { getAggRelayEnvironment } from '@townsquare/relay-utils/agg-environment';
import type { ResourceContext } from '@townsquare/router/types';
import { fg } from '@townsquare/stat-sig/gate';

import GoalGroupPermissionsSettingsAggQuery, {
	type GoalGroupPermissionsSettingsAggQuery as GoalGroupPermissionsSettingsAggQueryType,
} from '../../components/GroupPermissionsSettings/__generated__/GoalGroupPermissionsSettingsAggQuery.graphql';

export const goalGroupsSettingsResource =
	createRelayResource<GoalGroupPermissionsSettingsAggQueryType>({
		getQuery: (_routerContext, resourceContext) => {
			const context = resourceContext as ResourceContext;

			const variables: VariablesOf<GoalGroupPermissionsSettingsAggQueryType> = {
				containerId: context.collabContext?.contextId ?? '',
				isM3GroupPermsEnabled: fg('townsquare_m3_group_permissions'),
			};

			return {
				query: GoalGroupPermissionsSettingsAggQuery,
				variables,
				environment: getAggRelayEnvironment(),
			};
		},
	});
